import { DialogContent } from '@mui/material';
import { styled } from '@mui/material/styles';

interface DialogContentGlyntProps {
  children: React.ReactNode;
  paddingTop?: string | number;
  scrollable?: boolean;
}

const StyledDialogContent = styled(DialogContent, {
  shouldForwardProp: (prop) => prop !== '$paddingTop' && prop !== '$scrollable',
})<{
  $paddingTop?: string | number;
  $scrollable?: boolean;
}>`
  && {
    padding-left: 16px !important;
    padding-right: 16px !important;
    padding-bottom: 16px !important;
    padding-top: ${({ $paddingTop }) => $paddingTop || '16px'} !important;
    overflow: ${({ $scrollable }) => ($scrollable ? 'auto' : 'visible')} !important;
    -webkit-overflow-scrolling: touch;
  }
`;

const DialogContentGlynt: React.FC<DialogContentGlyntProps> = ({
  children,
  paddingTop,
  scrollable = false,
}) => {
  return (
    <StyledDialogContent $paddingTop={paddingTop} $scrollable={scrollable}>
      {children}
    </StyledDialogContent>
  );
};

export default DialogContentGlynt;
